<template>
    <div>
        <div style="display: flex; align-items: center; justify-content: space-between">
            <a-breadcrumb style="margin: 16px 0">
                <a-breadcrumb-item>主页</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectFirstMenu }}</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectSecondMenu }}</a-breadcrumb-item>
            </a-breadcrumb>
            <div>
                <a-button class="qinang-button-margin" type="primary" icon="plus" @click="tableAdd">新增</a-button>
                <a-button class="qinang-button-margin" icon="copy" @click="tableCopy">价格复制</a-button>
                <a-button class="qinang-button-margin" icon="edit" @click="tableEdit" :disabled="!tableSelectedRows || tableSelectedRows.length !== 1">修改</a-button>
                <a-button class="qinang-button-margin" icon="delete" @click="tableDel" :disabled="!tableSelectedRows || tableSelectedRows.length === 0">删除</a-button>
                <a-button icon="sync" @click="apiDistributorPriceQueryList">刷新</a-button>
            </div>
        </div>

        <a-collapse expandIconPosition="right" activeKey="1">
            <a-collapse-panel key="1" header="分销价格查询">
                <div class="qinang-search-row">
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title" style="width: 120px">服务商：</div>
                        <a-select v-model="query.facilitatorId" show-search option-filter-prop="children" style="width: 100%" placeholder="请选择服务商" allowClear>
                            <a-select-option v-for="(item, index) in facilitatorList" :value="item.facilitatorId" :key="index">{{ item.facilitatorName }}</a-select-option>
                        </a-select>
                    </div>
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title" style="width: 120px">分销商：</div>
                        <a-input v-model="query.distributorName" style="width: 100%" placeholder="请输入分销商名称" />
                    </div>
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title" style="width: 120px">优惠方式：</div>
                        <a-select v-model="query.discountType" style="width: 100%" placeholder="请选择优惠方式" allowClear>
                            <a-select-option v-for="(item, index) in discountTypeList" :value="item.value" :key="index">{{ item.label }}</a-select-option>
                        </a-select>
                    </div>
                </div>
                <div class="qinang-search-row" style="margin-top: 10px">
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title" style="width: 120px">状态：</div>
                        <a-select v-model="query.priceState" style="width: 100%" placeholder="请选择状态" allowClear>
                            <a-select-option v-for="(item, index) in priceStateList" :value="item.value" :key="index">{{ item.label }}</a-select-option>
                        </a-select>
                    </div>
                    <div class="qinang-search-col-3"></div>
                    <div class="qinang-search-col-3"></div>
                </div>
                <div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center">
                    <a-button type="primary" icon="search" @click="apiDistributorPriceQueryList">查询</a-button>
                    <a-button icon="redo" @click="resetQuery" style="margin-left: 14px">重置</a-button>
                </div>
            </a-collapse-panel>
        </a-collapse>

        <div class="qinang-card">
            <div style="display: flex; justify-content: space-between; align-items: center">
                <a-breadcrumb separator=">" style="padding: 12.5px 16px">
                    <a-breadcrumb-item>分销价格列表</a-breadcrumb-item>
                </a-breadcrumb>
            </div>
            <a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="distributorPriceId" :loading="tableLoading" :pagination="false">
                <span slot="facilitator" slot-scope="facilitator">
                    {{ facilitatorName(facilitator.facilitatorId) }}
                </span>
                <span slot="priceId" slot-scope="priceId">
                    {{ priceName(priceId.priceId) }}
                </span>
                <span slot="distributor" slot-scope="distributor">
                    <a-button type="link" @click="edit(distributor)">{{ distributorName(distributor.distributorId) }}</a-button>
                </span>
                <span slot="discountType" slot-scope="discountType">
                    {{ discountTypeMap[discountType.discountType] }}
                </span>
                <span slot="settlementPrice" slot-scope="settlementPrice">
                    <span v-if="settlementPrice.discountType == 2">{{ (settlementPrice.settlementPrice / 100).toFixed(2) }}</span>
                    <span v-else>-</span>
                </span>
                <span slot="settlementRate" slot-scope="settlementRate">
                    <span v-if="settlementRate.discountType == 3">{{ settlementRate.rate }}</span>
                    <span v-else>-</span>
                </span>
                <span slot="priceState" slot-scope="priceState">
                    {{ priceStateMap[priceState.priceState] }}
                </span>
                <span slot="createTime" slot-scope="createTime">
                    {{ qaUtil.timeFormat(createTime.createTime) }}
                </span>
            </a-table>
            <a-pagination style="text-align: right; margin: 10px" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']" :show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange" />
        </div>

        <!-- 添加弹窗 -->
        <a-modal class="qa-modal-hf" title="添加" width="900px" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false">
            <a-form-model ref="addRuleForm" :model="addForm" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" :rules="addRules">
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="服务商" prop="facilitatorId">
                            <a-select v-model="addForm.facilitatorId" @change="onAddFacilitatorChange" show-search option-filter-prop="children" placeholder="请选择服务商" allowClear>
                                <a-select-option v-for="(item, index) in facilitatorList" :value="item.facilitatorId" :key="index">{{ item.facilitatorName }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="分销商" prop="distributorId">
                            <a-select v-model="addForm.distributorId" show-search :filter-option="false" @search="searchDistributor" placeholder="请输入分销商名称搜索" allowClear>
                                <a-select-option v-for="(item, index) in distributorOptions" :value="item.distributorId" :key="index">{{ item.distributorName }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="24">
                        <a-form-model-item label="产品价格" prop="priceId" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                            <a-select v-model="addForm.priceId" show-search option-filter-prop="children" placeholder="请选择产品" allowClear>
                                <a-select-option v-for="(item, index) in priceList" :value="item.priceId" :key="index">{{ item.productName }}【{{ item.crowdtypeName }}】({{ item.listingPrice / 100 }}元)</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="优惠方式" prop="discountType">
                            <a-radio-group name="discountType" v-model="addForm.discountType">
                                <a-radio v-for="item in discountTypeList" :value="item.value" :key="item.value">{{ item.label }}</a-radio>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12" v-if="addForm.discountType == 2">
                        <a-form-model-item label="采购价(元)" prop="settlementPrice">
                            <a-input-number v-model="addForm.settlementPrice" :min="0" :step="0.01" style="width: 100%" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12" v-if="addForm.discountType == 3">
                        <a-form-model-item label="采购比例" prop="rate">
                            <a-input-number v-model="addForm.rate" :min="0" :max="1" :step="0.01" style="width: 100%" />
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="状态" prop="priceState">
                            <a-select v-model="addForm.priceState" placeholder="请选择状态" style="width: 100%">
                                <a-select-option v-for="(item, index) in priceStateList" :value="item.value" :key="index">{{ item.label }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="24">
                        <a-form-model-item label="备注" prop="remarks" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                            <a-textarea v-model="addForm.remarks" placeholder="请输入备注，非必填项" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </a-modal>

        <!-- 修改弹窗 -->
        <a-modal class="qa-modal-hf" title="修改" width="900px" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false">
            <a-form-model ref="editRuleForm" :model="editForm" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" :rules="addRules">
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="服务商" prop="facilitatorId">
                            <a-select v-model="editForm.facilitatorId" @change="onEditFacilititorChange" show-search option-filter-prop="children" placeholder="请选择服务商" allowClear>
                                <a-select-option v-for="(item, index) in facilitatorList" :value="item.facilitatorId" :key="index">{{ item.facilitatorName }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="分销商" prop="distributorId">
                            <a-select v-model="editForm.distributorId" show-search :filter-option="false" @search="searchDistributor" placeholder="请输入分销商名称搜索" allowClear>
                                <a-select-option v-for="(item, index) in distributorOptions" :value="item.distributorId" :key="index">{{ item.distributorName }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="24">
                        <a-form-model-item label="产品价格" prop="priceId" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                            <a-select v-model="editForm.priceId" show-search option-filter-prop="children" placeholder="请选择产品" allowClear>
                                <a-select-option v-for="(item, index) in priceList" :value="item.priceId" :key="index">{{ item.productName }}【{{ item.crowdtypeName }}】({{ item.listingPrice / 100 }}元)</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="优惠方式" prop="discountType">
                            <a-radio-group name="discountType" v-model="editForm.discountType">
                                <a-radio v-for="item in discountTypeList" :value="item.value" :key="item.value">{{ item.label }}</a-radio>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12" v-if="editForm.discountType == 2">
                        <a-form-model-item label="采购价(元)" prop="settlementPrice">
                            <a-input-number v-model="editForm.settlementPrice" :min="0" :step="0.01" style="width: 100%" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12" v-if="editForm.discountType == 3">
                        <a-form-model-item label="采购比例" prop="rate">
                            <a-input-number v-model="editForm.rate" :min="0" :max="1" :step="0.01" style="width: 100%" />
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="状态" prop="priceState">
                            <a-select v-model="editForm.priceState" placeholder="请选择状态" style="width: 100%">
                                <a-select-option v-for="(item, index) in priceStateList" :value="item.value" :key="index">{{ item.label }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="24">
                        <a-form-model-item label="备注" prop="remarks" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                            <a-textarea v-model="editForm.remarks" placeholder="请输入备注，非必填项" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </a-modal>

        <!-- 复制弹窗 -->
        <a-modal class="qa-modal-hf" title="价格复制" :visible="copyVisible" :confirm-loading="copyConfirmLoading" @ok="copyHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false">
            <div>
                <div style="margin-bottom: 30px">
                    <a-tag color="orange" style="font-size: 16px; padding: 4px 12px; line-height: 24px; border-radius: 6px; white-space: normal; word-break: break-word; width: 100%"> 把一位分销商已经设好的产品价格，复制给另一位（或几位）分销商；对方有相同产品就更新，没有即添加。 </a-tag>
                </div>
            </div>
            <a-form-model ref="copyRuleForm" :model="copyForm" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" :rules="copyRules">
                <a-form-model-item label="服务商" prop="facilitatorId">
                    <a-select v-model="copyForm.facilitatorId" show-search option-filter-prop="children" placeholder="请选择服务商" allowClear>
                        <a-select-option v-for="(item, index) in facilitatorList" :value="item.facilitatorId" :key="index">{{ item.facilitatorName }}</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="被复制用户" prop="sourceDistributorId">
                    <a-select v-model="copyForm.sourceDistributorId" show-search :filter-option="false" @search="searchCopyDistributor" placeholder="模板用户，输入名称搜索" allowClear>
                        <a-select-option v-for="(item, index) in copyDistributorOptions" :value="item.distributorId" :key="index">{{ item.distributorName }}</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="待复制用户" prop="targetDistributorIds">
                    <a-select mode="multiple" v-model="copyForm.targetDistributorIds" show-search :filter-option="false" @search="searchCopyDistributor" placeholder="复制给谁，可多选" allowClear>
                        <a-select-option v-for="(item, index) in copyDistributorOptions" :value="item.distributorId" :key="index">{{ item.distributorName }}</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="复制字段">
                    <a-checkbox-group v-model="copySelectedFields">
                        <a-checkbox v-for="item in copyFieldList" :value="item.value" :key="item.value" style="margin-left: 8px">{{ item.label }}</a-checkbox>
                    </a-checkbox-group>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selectFirstMenu: window.sessionStorage.getItem("selectFirstMenu"),
            selectSecondMenu: window.sessionStorage.getItem("selectSecondMenu"),
            facilitatorList: [],
            distributorList: [],
            distributorOptions: [],
            priceList: [],
            priceAllList: [],
            discountTypeList: [
                { label: "采购价", value: 2 },
                { label: "采购比例", value: 3 }
            ],
            priceStateList: [
                { label: "停用", value: 2 },
                { label: "启用", value: 3 }
            ],
            discountTypeMap: { 2: "采购价", 3: "采购比例" },
            priceStateMap: { 2: "停用", 3: "启用" },
            query: {
                page: 1,
                size: 10,
                total: 0,
                facilitatorId: undefined,
                distributorName: undefined,
                discountType: undefined,
                priceState: undefined
            },
            tableData: [],
            tableColumns: [
                { title: "ID", dataIndex: "distributorPriceId", key: "distributorPriceId", align: "center", width: "80" },
                { title: "服务商", key: "facilitator", align: "center", width: "150", scopedSlots: { customRender: "facilitator" } },
                { title: "分销商", key: "distributor", align: "center", width: "150", scopedSlots: { customRender: "distributor" } },
                { title: "产品价格", key: "priceId", align: "center", width: "150", scopedSlots: { customRender: "priceId" } },
                { title: "优惠方式", key: "discountType", align: "center", width: "110", scopedSlots: { customRender: "discountType" } },
                { title: "采购价(元)", key: "settlementPrice", align: "center", width: "120", scopedSlots: { customRender: "settlementPrice" } },
                { title: "采购比例", key: "settlementRate", align: "center", width: "120", scopedSlots: { customRender: "settlementRate" } },
                { title: "状态", key: "priceState", align: "center", width: "100", scopedSlots: { customRender: "priceState" } },
                { title: "备注", dataIndex: "remarks", key: "remarks", align: "center", width: "150" },
                { title: "创建时间", key: "createTime", align: "center", scopedSlots: { customRender: "createTime" } }
            ],
            tableLoading: false,
            tableSelectedRows: [],

            copyDistributorOptions: [], // 复制弹窗
            copyVisible: false, // 复制弹窗显示开关
            copyConfirmLoading: false,
            copyFieldList: [
                { label: "优惠方式", value: "discountType" },
                { label: "采购价", value: "settlementPrice" },
                { label: "采购比例", value: "settlementParam" },
                { label: "状态", value: "priceState" },
                { label: "备注", value: "remarks" }
            ],
            copySelectedFields: ["discountType", "settlementPrice", "settlementParam"],
            copyForm: {
                facilitatorId: undefined,
                sourceDistributorId: undefined,
                targetDistributorIds: []
            },
            copyRules: {
                facilitatorId: [{ required: true, message: "请选择服务商", trigger: "change" }],
                sourceDistributorId: [{ required: true, message: "请选择被复制用户", trigger: "change" }],
                targetDistributorIds: [{ required: true, type: "array", message: "请选择待复制用户", trigger: "change" }]
            },
            addVisible: false,
            addConfirmLoading: false,
            addForm: {
                facilitatorId: undefined,
                distributorId: undefined,
                priceId: undefined,
                discountType: 2,
                settlementPrice: 0,
                rate: 0,
                priceState: 3,
                remarks: ""
            },
            addRules: {
                facilitatorId: [{ required: true, message: "请选择服务商", trigger: "change" }],
                distributorId: [{ required: true, message: "请选择分销商", trigger: "change" }],
                priceId: [{ required: true, message: "产品价格不能为空", trigger: "change" }],

                discountType: [{ required: true, message: "请选择优惠方式", trigger: "change" }],
                priceState: [{ required: true, message: "请选择状态", trigger: "change" }]
            },
            editVisible: false,
            editConfirmLoading: false,
            editForm: {
                distributorPriceId: "",
                facilitatorId: undefined,
                distributorId: undefined,
                priceId: undefined,
                discountType: 2,
                settlementPrice: 0,
                rate: 0,
                priceState: 3,
                remarks: ""
            }
        }
    },
    methods: {
        async apiFacilitatorList() {
            const { data: res } = await this.$http.post(this.navigation.apiFacilitatorList, { staffId: window.sessionStorage.getItem("staffId") })
            if (res.code == 200) {
                this.facilitatorList = res.data
            } else {
                this.$message.error(res.msg)
            }
        },
        async apiDistributorList() {
            const { data: res } = await this.$http.post(this.navigation.apiDistributorList, {})
            if (res.code == 200) {
                this.distributorList = res.data
            } else {
                this.$message.error(res.msg)
            }
        },
        facilitatorName(facilitatorId) {
            if (!facilitatorId) return ""
            const f = this.facilitatorList.find(item => item.facilitatorId == facilitatorId)
            return f ? f.facilitatorName : facilitatorId
        },
        distributorName(distributorId) {
            if (!distributorId) return ""
            const d = this.distributorList.find(item => item.distributorId == distributorId)
            return d ? d.distributorName : distributorId
        },
        async apiPriceAllList() {
            const { data: res } = await this.$http.post(this.navigation.apiPriceList, {})
            if (res.code == 200) {
                this.priceAllList = res.data || []
            }
        },
        priceName(priceId) {
            if (!priceId) return ""
            const p = this.priceAllList.find(item => item.priceId == priceId)
            return p ? p.productName + "【" + p.crowdtypeName + "】(" + p.listingPrice / 100 + "元)" : priceId
        },

        parseRate(param) {
            try {
                return JSON.parse(param).rate || 0
            } catch (e) {
                return 0
            }
        },
        resetQuery() {
            this.query = {
                page: 1,
                size: 10,
                total: 0,
                facilitatorId: undefined,
                distributorName: undefined,
                discountType: undefined,
                priceState: undefined
            }
            this.apiDistributorPriceQueryList()
        },

        async apiDistributorPriceQueryList() {
            this.tableLoading = true
            const { data: res } = await this.$http.post(this.navigation.apiDistributorPriceQueryList, this.query)
            if (res.code == 200) {
                this.tableData = (res.data.list || []).map(item => {
                    let rate = "-"
                    if (item.discountType == 3 && item.settlementParam) {
                        try {
                            rate = JSON.parse(item.settlementParam).rate
                        } catch (e) {
                            rate = "-"
                        }
                    }
                    return { ...item, rate }
                })
                this.query.page = res.data.pages.page
                this.query.size = res.data.pages.size
                this.query.total = res.data.pages.total
                this.tableLoading = false
            } else {
                this.$message.error(res.msg)
                this.tableLoading = false
            }
        },
        searchDistributor(keyword) {
            if (!keyword) {
                this.distributorOptions = []
                return
            }
            this.$http.post(this.navigation.apiDistributorQueryList, { page: 1, size: 50, distributorName: keyword }).then(({ data: res }) => {
                if (res.code == 200 && res.data && res.data.list) {
                    this.distributorOptions = res.data.list
                }
            })
        },

        pageChange(page, pageSize) {
            this.query.page = page
            this.query.size = pageSize
            this.apiDistributorPriceQueryList()
        },
        showSizeChange(current, size) {
            this.query.page = current
            this.query.size = size
            this.apiDistributorPriceQueryList()
        },
        handleCancel() {
            this.addVisible = false
            this.editVisible = false
            this.copyVisible = false
        },

        tableCopy() {
            this.copyVisible = true
            this.copyConfirmLoading = false
            this.copyForm = {
                facilitatorId: undefined,
                sourceDistributorId: undefined,
                targetDistributorIds: []
            }
            this.copyDistributorOptions = []
            this.copySelectedFields = ["discountType", "settlementPrice", "priceState", "remarks", "settlementParam"]
            if (this.$refs.copyRuleForm) this.$refs.copyRuleForm.resetFields()
        },

        copyHandleOk() {
            this.$refs.copyRuleForm.validate(valid => {
                if (valid) {
                    this.apiDistributorPriceCopy()
                } else {
                    return false
                }
            })
        },
        async apiDistributorPriceCopy() {
            if (this.copyForm.targetDistributorIds.includes(this.copyForm.sourceDistributorId)) {
                this.$message.warning("待复制用户里不能包含被复制用户")
                return
            }
            this.copyConfirmLoading = true
            const { data: res } = await this.$http.post(this.navigation.apiDistributorPriceCopy, this.copyForm)
            if (res.code == 200) {
                this.$message.success(res.msg)
                this.copyConfirmLoading = false
                this.copyVisible = false
                this.apiDistributorPriceQueryList()
            } else {
                this.$message.error(res.msg)
                this.copyConfirmLoading = false
            }
        },
        searchCopyDistributor(keyword) {
            if (!keyword) {
                this.copyDistributorOptions = []
                return
            }
            this.$http.post(this.navigation.apiDistributorQueryList, { page: 1, size: 50, distributorName: keyword }).then(({ data: res }) => {
                if (res.code == 200 && res.data && res.data.list) {
                    const seenDistributorIds = {}
                    this.copyDistributorOptions = [...this.copyDistributorOptions, ...res.data.list].filter(item => {
                        if (seenDistributorIds[item.distributorId]) return false
                        seenDistributorIds[item.distributorId] = true
                        return true
                    })
                }
            })
        },

        tableAdd() {
            this.addVisible = true
            this.addConfirmLoading = false
            this.addForm = {
                facilitatorId: undefined,
                distributorId: undefined,
                priceId: undefined,
                discountType: 2,
                settlementPrice: 0,
                rate: 0,
                priceState: 3,
                remarks: ""
            }
            this.priceList = []
            this.distributorOptions = []
            if (this.$refs.addRuleForm) this.$refs.addRuleForm.resetFields()
        },
        buildParams(form) {
            const params = { ...form }
            params.facilitatorId = params.facilitatorId || 0
            params.distributorId = params.distributorId || 0
            params.priceId = params.priceId || 0
            params.priceState = params.priceState || 3
            if (params.discountType == 2) {
                params.settlementPrice = params.settlementPrice ? Math.round(params.settlementPrice * 100) : 0
                params.settlementParam = ""
            } else {
                params.settlementPrice = 0
                const rate = params.rate ? Number(params.rate) : 0
                params.settlementParam = JSON.stringify({ rate: rate })
            }
            delete params.rate
            return params
        },
        async apiDistributorPriceAdd() {
            this.addConfirmLoading = true
            const params = this.buildParams(this.addForm)
            const { data: res } = await this.$http.post(this.navigation.apiDistributorPriceAdd, params)
            if (res.code == 200) {
                this.$message.success(res.msg)
                if (this.$refs.addRuleForm) this.$refs.addRuleForm.resetFields()
                this.addConfirmLoading = false
                this.addVisible = false
                this.apiDistributorPriceQueryList()
            } else {
                this.$message.error(res.msg)
                this.addConfirmLoading = false
            }
        },
        addHandleOk() {
            this.$refs.addRuleForm.validate(valid => {
                if (valid) {
                    this.apiDistributorPriceAdd()
                } else {
                    return false
                }
            })
        },
        async edit(item) {
            this.editConfirmLoading = false
            this.editVisible = true
            const facilitatorId = item.facilitatorId || undefined
            this.editForm = {
                distributorPriceId: item.distributorPriceId,
                facilitatorId: facilitatorId,
                distributorId: item.distributorId || undefined,
                priceId: undefined,
                discountType: item.discountType,
                settlementPrice: item.discountType == 2 ? (item.settlementPrice ? item.settlementPrice / 100 : 0) : 0,
                rate: item.discountType == 3 && item.settlementParam ? this.parseRate(item.settlementParam) : 0,
                priceState: item.priceState,
                remarks: item.remarks || ""
            }
            this.priceList = []
            this.distributorOptions = []
            if (this.editForm.distributorId && this.distributorList.length) {
                const d = this.distributorList.find(x => x.distributorId == this.editForm.distributorId)
                if (d) this.distributorOptions = [d]
            }

            if (facilitatorId) {
                await this.apiPriceList(facilitatorId)
            }
            this.editForm.priceId = item.priceId
        },
        async apiDistributorPriceEdit() {
            this.editConfirmLoading = true
            const params = this.buildParams(this.editForm)
            params.distributorPriceId = this.editForm.distributorPriceId
            const { data: res } = await this.$http.post(this.navigation.apiDistributorPriceEdit, params)
            if (res.code == 200) {
                this.$message.success(res.msg)
                this.editConfirmLoading = false
                this.editVisible = false
                this.apiDistributorPriceQueryList()
            } else {
                this.$message.error(res.msg)
                this.editConfirmLoading = false
            }
        },
        editHandleOk() {
            this.$refs.editRuleForm.validate(valid => {
                if (valid) {
                    this.apiDistributorPriceEdit()
                } else {
                    return false
                }
            })
        },
        tableDel() {
            let that = this
            if (this.tableSelectedRows.length > 0) {
                const ids = this.tableSelectedRows.map(row => row.distributorPriceId)
                this.$confirm({
                    title: "确定要删除当前选中数据吗",
                    content: "当前选中" + ids.length + "条数据。",
                    okText: "确定",
                    okType: "danger",
                    cancelText: "取消",
                    onOk() {
                        that.apiDistributorPriceDel(ids)
                    },
                    onCancel() {}
                })
            } else {
                this.$message.warning("请选择要删除的数据")
            }
        },
        async apiDistributorPriceDel(ids) {
            const { data: res } = await this.$http.post(this.navigation.apiDistributorPriceDel + "/" + ids)
            if (res.code == 200) {
                this.$message.success(res.msg)
                await this.apiDistributorPriceQueryList()
            } else {
                this.$message.error(res.msg)
            }
        },
        tableEdit() {
            if (this.tableSelectedRows.length === 1) {
                const item = this.tableData.find(item => item.distributorPriceId == this.tableSelectedRows[0].distributorPriceId)
                this.edit(item)
            } else {
                this.$message.warning("请选择要修改的数据")
            }
        },
        async apiPriceList(facilitatorId) {
            const { data: res } = await this.$http.post(this.navigation.apiPriceList, { facilitatorId: facilitatorId })
            if (res.code == 200) {
                this.priceList = res.data
            }
        },
        onAddFacilitatorChange(facilitatorId) {
            this.addForm.priceId = undefined
            this.priceList = []
            if (facilitatorId) this.apiPriceList(facilitatorId)
        },
        onEditFacilitatorChange(facilitatorId) {
            this.editForm.priceId = undefined
            this.priceList = []
            if (facilitatorId) this.apiPriceList(facilitatorId)
        }
    },
    computed: {
        rowSelection() {
            let that = this
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    that.tableSelectedRows = selectedRows
                }
            }
        }
    },
    created() {
        this.apiFacilitatorList()
        this.apiDistributorList()
        this.apiPriceAllList()
        this.apiDistributorPriceQueryList()
    }
}
</script>

<style scoped>
.qa-modal ::v-deep .ant-form {
    overflow-y: auto;
}
.qa-modal ::v-deep .ant-modal {
    width: auto !important;
    max-width: 80vw;
}
.qa-modal ::v-deep .ant-modal-content {
    background-color: #fff;
    width: auto;
}
.qa-modal ::v-deep .ant-modal-body {
    max-height: calc(100vh - 110px);
    overflow-y: auto;
    padding: 24px;
    width: auto;
    position: relative;
}
</style>
